import { render } from "./ReadOurStoryComponent.vue?vue&type=template&id=a2f04ef4"
import script from "./ReadOurStoryComponent.vue?vue&type=script&lang=js"
export * from "./ReadOurStoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__